<template>
  <v-dialog v-model="dialog.show" max-width="500px" persistent>
    <v-card>
      <v-card-title> </v-card-title>
      <font-awesome-icon :icon="dialog.icon" size="4x" />
      <v-card-text
        ><b style="line-height:2; font-size: 100%;" v-html="dialog.message"> </b
      ></v-card-text>

      <v-card-actions v-if="dialog.type == 0">
        <v-btn color="primary white--text" rounded @click="$emit('close')">
          بستن
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <div class="halfPage">
          <v-btn
            color="primary white--text"
            rounded
            @click="$emit('close', dialog.key)"
          >
            بلی
          </v-btn>
        </div>
        <div class="halfPage">
          <v-btn color="orange white--text" rounded @click="$emit('close', -1)">
            خیر
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    icon() {
      return "../assets/" + this.dialog.icon + ".png";
    },
    dialog() {
      return this.$store.getters.dialog;
    },
  },
};
</script>
<style scoped>
.v-btn {
  width: 100%;
  margin: 15px 0;
}

.v-card__text {
  padding: 20px 50px 0px 50px !important;
  font-size: 18px;
  text-align: center;
}

.v-card {
  margin: 0;
  border-radius: 4px !important;
}

.halfPage {
  padding: 10px 15px;
}

.fa-times {
  color: unset !important;
  margin-top: unset !important;

  float: unset !important;
  cursor: unset !important;
  margin-right: 0 !important;
}
</style>
